import { IEntity } from './IEntity';

export interface IKeyValueLog extends IEntity {
	key: string;

	value: string;
}

export const resourceNameKeyValueLogs = `keyvaluelog`;